import "mapbox-gl/dist/mapbox-gl.css";
/* eslint import/no-webpack-loader-syntax: off */
import mapboxgl from "!mapbox-gl";
import React, { useState, useRef, useEffect } from "react";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESSTOKEN;
// shape of the props
// {
//  positionInfos: [{address: "some address"}]
// }

const MapBox = ({
  setOnClickFlag,
  onTripDetails,
  globalCityField,
  setMapClickData,
  mapClickData,
}) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(78.9629);
  const [lat, setLat] = useState(20.5937);
  const [zoom, setZoom] = useState(4);

  const [mapMarkers, setMapMarkers] = useState([]);

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [lng, lat],
      zoom: zoom,
    });
    // map.addControl(
    //   new MapboxDirections({
    //   accessToken: mapboxgl.accessToken
    //   }),
    //   'top-left'
    //   );
    // create a function to make a directions request
  }, []);
  const checkMarkertoRemove = () => {
    const indexs=[];
    mapMarkers.forEach((element,index) => {
      if(element.selected){
        indexs.push(index)
      }
    });
    if (indexs.length==0) return;
    indexs.forEach(element=>{
      const mapObj = mapMarkers[element]
      mapObj.marker.remove();
      let marker = new mapboxgl.Marker({ color: "red" })
        .setLngLat([mapObj.lng, mapObj.lat])
        .addTo(map.current);
  
      marker.getElement().addEventListener("click", () => {
        setOnClickFlag(true);
        setMapClickData(mapObj.element);
      });
    })

  };

  useEffect(() => {
    if (!mapClickData) return;
    checkMarkertoRemove();
    const index = mapMarkers.findIndex(
      (element) =>
        element.element.megaCabsBookingNo == mapClickData.megaCabsBookingNo
    );
    let mapObj;
    if (index != -1) {
      mapObj = mapMarkers[index];
    }

    if (!mapObj) return;

    mapObj.marker.remove();
    let marker = new mapboxgl.Marker({ color: "green" })
      .setLngLat([mapObj.lng, mapObj.lat])
      .addTo(map.current);

    marker.getElement().addEventListener("click", () => {
      setOnClickFlag(true);
      setMapClickData(mapObj.element);
    });
    setMapMarkers((prevData) => {
      prevData[index].marker = marker;
      prevData[index].selected = true;
      return prevData;
    });
  }, [mapClickData]);

  useEffect(() => {
    mapMarkers.forEach((element) => {
      element.marker.remove();
    });
    const array = [];
    let centerFlag = false;
    onTripDetails.forEach((element, index) => {
      if (!element.destLng || !element.destLat) return;
      if (!centerFlag && globalCityField.value?.id) {
        map.current.setCenter([element.destLng, element.destLat]);
        map.current.setZoom(9);
        centerFlag = true;
      }else if(!centerFlag && !globalCityField.value?.id){
        map.current.setCenter([lng, lat]);
        map.current.setZoom(4);
        centerFlag = true;
      }
      const point = [element.destLng, element.destLat];
      let marker = new mapboxgl.Marker({ color: "red" })
        .setLngLat(point)
        .addTo(map.current);

      marker.getElement().addEventListener("click", () => {
        setOnClickFlag(true);
        setMapClickData(element);
      });
      array.push({
        marker: marker,
        selected: false,
        lng: element.destLng,
        lat: element.destLat,
        element: element,
      });
    });
    console.log(array.length, "lengthissiisisis");
    setMapMarkers(array);

    // // Create a default Marker, colored black, rotated 45 degrees.
    // const marker2 = new mapboxgl.Marker({ color: "red" }).setLngLat(point2).addTo(map.current);

    // marker2.getElement().addEventListener('click', () => {
    //   setOnClickFlag(true)
    // });

    // const marker3 = new mapboxgl.Marker({ color: "red" }).setLngLat(point3).addTo(map.current);

    // marker3.getElement().addEventListener('click', () => {
    //   setOnClickFlag(true)
    // });
  }, [onTripDetails]);

  return <div ref={mapContainer} className="map-container" />;
};

export default MapBox;
